import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
import LoginPage from "./LoginPage";

function ClaimsAdminPage() {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const statusOptions = [
    "Initial Documentation Received",
    "Under Review",
    "Survey Assigned",
    "Assessment in Progress",
    "Final Report Issued",
    "Closed",
  ];

  useEffect(() => {
    fetchClaims();
  }, []);

  const fetchClaims = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/get-all-claims`);
      const data = await response.json();

      console.log("API response:", data);

      // adjust based on your API structure
      setClaims(data.claims || data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // function updateStatus(claimId, newStatus) {
  //   // Optimistic UI update (instant feel)
  //   const updatedClaims = claims.map(function (claim) {
  //     if (claim.claimId === claimId) {
  //       return { ...claim, currentStatus: newStatus };
  //     }
  //     return claim;
  //   });

  //   setClaims(updatedClaims);

  //   // API call
  //   fetch(`${API_BASE_URL}/update-claim`, {
  //     method: "PUT", // or PATCH based on your backend
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       currentStatus: newStatus,
  //     }),
  //   })
  //     .then(function (res) {
  //       if (!res.ok) {
  //         throw new Error("Failed to update");
  //       }
  //     })
  //     .catch(function (err) {
  //       console.error("Update failed:", err);

  //       // rollback if API fails
  //       fetch(`${API_BASE_URL}/get-all-claims`)
  //         .then(function (res) {
  //           return res.json();
  //         })
  //         .then(function (data) {
  //           setClaims(data?.claims || data);
  //         });
  //     });
  // }

  const updateClaim = async (claimId, newStatus) => {
    try {
      const claim = claims.find((c) => c.claimId === claimId);
      if (!claim) {
        console.error("Claim not found:", claimId);
        return;
      }
      const response = await fetch(`${API_BASE_URL}/update-claim`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          submissionDate: claim?.submissionDate,
          vesselName: claim?.vesselName,
          claimType: claim?.claimType,
          currentStatus: newStatus,
          claimId: claim?.claimId,
          description: claim?.description,
          email: claim?.email,
          incidentDate: claim?.incidentDate,
        }),
      });

      const data = await response.text(); // or response.json() if API returns JSON
      console.log("Success:", data);
      fetchClaims();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  function formatDate(date) {
    return new Date(date).toLocaleDateString();
  }

  if (!isAuthenticated) {
    return <LoginPage onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <div className="page-root">
      <header className="hero">
        <a className="home-link" href="./" aria-label="Home">
          <svg
            className="home-icon"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
          </svg>
          Home
        </a>

        <div className="hero-content" id="new-claims">
          <h1>Marine Claims & Adjusting Admin</h1>
        </div>
      </header>
      <main>
        <section style={{ padding: "4rem 3rem" }}>
          <div className="max-w-[90rem] mx-auto">
            <h2
              style={{
                fontSize: "1.875rem",
                fontWeight: "700",
                textAlign: "center",
                marginBottom: "2rem",
              }}
            >
              Claims Management Dashboard
            </h2>

            {/* TABLE */}
            <div
              style={{
                overflowX: "auto",
                border: "1px solid #e5e7eb",
                borderRadius: "0.75rem",
                background: "#fff",
              }}
            >
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead style={{ background: "#f8fafc" }}>
                  <tr>
                    <th style={thStyle}>Claim ID</th>
                    <th style={thStyle}>Vessel</th>
                    <th style={thStyle}>Type</th>
                    <th style={thStyle}>Incident Date</th>
                    <th style={thStyle}>Email</th>
                    <th style={thStyle}>Status</th>
                    <th style={thStyle}>Update</th>
                  </tr>
                </thead>

                <tbody>
                  {claims.map(function (claim) {
                    return (
                      <tr
                        key={claim.claimId}
                        style={{ borderTop: "1px solid #e5e7eb" }}
                      >
                        <td style={tdStyle}>{claim.claimId}</td>
                        <td style={tdStyle}>{claim.vesselName}</td>
                        <td style={tdStyle}>{claim.claimType}</td>
                        <td style={tdStyle}>
                          {formatDate(claim.incidentDate)}
                        </td>
                        <td style={tdStyle}>{claim.email}</td>

                        {/* STATUS DISPLAY */}
                        <td style={tdStyle}>
                          <span
                            style={{
                              padding: "0.25rem 0.6rem",
                              borderRadius: "0.4rem",
                              background: "#e0f2fe",
                              color: "#0369a1",
                              fontSize: "0.85rem",
                              fontWeight: "500",
                            }}
                          >
                            {claim.currentStatus}
                          </span>
                        </td>

                        {/* STATUS UPDATE */}
                        <td style={tdStyle}>
                          <select
                            value={claim.currentStatus}
                            onChange={function (e) {
                              updateClaim(claim.claimId, e.target.value);
                            }}
                            style={{
                              padding: "0.3rem 0.5rem",
                              borderRadius: "0.4rem",
                              border: "1px solid #cbd5f5",
                            }}
                          >
                            {statusOptions.map(function (status, index) {
                              return (
                                <option key={index} value={status}>
                                  {status}
                                </option>
                              );
                            })}
                          </select>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

// STYLES
const thStyle = {
  textAlign: "left",
  padding: "0.75rem",
  fontSize: "0.9rem",
  fontWeight: "600",
  color: "#334155",
};

const tdStyle = {
  padding: "0.75rem",
  fontSize: "0.9rem",
  color: "#475569",
};

export default ClaimsAdminPage;
